import { render, staticRenderFns } from "./ModalPerfisUsuarios.vue?vue&type=template&id=cc6fdd94&"
import script from "./ModalPerfisUsuarios.vue?vue&type=script&lang=js&"
export * from "./ModalPerfisUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports